export default __webpack_public_path__ + "static/media/14-Get-Virtual.0de6c2c2.jpg";